export const name = 'renderFlagsOverridesAspect'

export const defaultModel = {
    componentViewMode: 'editor',
    isSocialInteractionAllowed: false,
    isPlayingAllowed: false
}
